import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import styles from './RealEstate.module.css';

const RealEstate = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sectionRef = useRef(null);

  // Simple gallery data
  const properties = [
    {
      image: `${process.env.PUBLIC_URL}/images/lions.png`,
      price: '$4,298,000',
      description: 'home marketed and sold in partnership with Canacon Media'
    },
    {
      image: `${process.env.PUBLIC_URL}/images/spencer.png`,
      price: '$6,999,777',
      description: 'home marketed and sold in partnership with Canacon Media'
    },
    {
      image: `${process.env.PUBLIC_URL}/images/land.png`,
      price: '$5,999,000',
      description: 'industrial waterfront land marketed and sold in partnership with Canacon Media'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    // Store current ref value to avoid issues in cleanup
    const currentRef = sectionRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  // Simple navigation functions - no transitions
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % properties.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + properties.length) % properties.length);
  };

  return (
    <section className={styles.realEstate} id="realestate" ref={sectionRef}>
      <div className={styles.container}>
        <div className={`${styles.content} ${isVisible ? styles.visible : ''}`}>
          <div className={styles.badge}>
            <span className={styles.badgeText}>Real Estate Marketing</span>
          </div>
          <h2 className={styles.mainHeading}>
            <span className={styles.headingPrimary}>Digital Solutions</span>
            <span className={styles.headingSecondary}>for Realtors</span>
          </h2>
          
          <div className={styles.statsContainer}>
            <div className={styles.statItem}>
              <div className={styles.statValue}>
                <span className={styles.currency}>$</span>
                <span className={styles.amount}>300M+</span>
                <span className={styles.statLabel}>in successful listings</span>
                <span className={styles.soldBadge}>SOLD</span>
              </div>
            </div>
          </div>

          <div className={styles.servicesGrid}>
            <div className={styles.serviceItem}>
              <div className={styles.serviceIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 3L2 12H5V20H19V12H22L12 3Z" fill="currentColor"/>
                </svg>
              </div>
              <div className={styles.serviceContent}>
                <h4>Property Websites</h4>
                <p>Custom-built, conversion-optimized property showcase sites</p>
              </div>
            </div>
            
            <div className={styles.serviceItem}>
              <div className={styles.serviceIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L13.09 8.26L20 9.27L14.77 14.14L16.18 21.02L12 18.27L7.82 21.02L9.23 14.14L4 9.27L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <div className={styles.serviceContent}>
                <h4>Digital Marketing</h4>
                <p>Targeted campaigns that reach qualified buyers effectively</p>
              </div>
            </div>
            
            <div className={styles.serviceItem}>
              <div className={styles.serviceIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M3 3V21H21V3H3ZM19 19H5V5H19V19ZM7 12H9V17H7V12ZM11 7H13V17H11V7ZM15 10H17V17H15V10Z" fill="currentColor"/>
                </svg>
              </div>
              <div className={styles.serviceContent}>
                <h4>Performance Analytics</h4>
                <p>Data-driven insights to optimize your marketing ROI</p>
              </div>
            </div>
          </div>

          <Link to="/realestate" className={styles.ctaButton}>
            <span>Elevate Your Business</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>
        <div className={`${styles.imageSection} ${isVisible ? styles.visible : ''}`}>
          <div className={styles.galleryWrapper}>
            <div 
              className={styles.galleryTrack}
              style={{
                transform: `translateX(-${currentSlide * 33.333}%)`
              }}
            >
              {properties.map((property, index) => (
                <div
                  key={index}
                  className={styles.imageContainer}
                  style={{
                    backgroundImage: `url(${property.image})`
                  }}
                >
                  <div className={styles.ribbon}>
                    <span className={styles.ribbonText}>
                      {property.price} {property.description}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* Left Arrow */}
            <button className={styles.arrowLeft} onClick={prevSlide}>
              ‹
            </button>

            {/* Right Arrow */}
            <button className={styles.arrowRight} onClick={nextSlide}>
              ›
            </button>

            {/* Red Indicator Bars */}
            <div className={styles.indicators}>
              {properties.map((_, index) => (
                <div
                  key={index}
                  className={`${styles.indicator} ${currentSlide === index ? styles.active : ''}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RealEstate; 